import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Platforms from './pages/Platforms';
import BrontoAIPage from './pages/BrontoAIPage';
import BrontoYPage from './pages/BrontoYPage';
import MSPConnectPage from './pages/MSPConnectPage';
import BrontoCosmosPage from './pages/BrontoCosmosPage';
import Leadership from './pages/Leadership';
import LeaderProfile from './pages/LeaderProfile';
import Media from './pages/Media';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/platforms" element={<Platforms />} />
            <Route path="/brontoai" element={<BrontoAIPage />} />
            <Route path="/brontoy" element={<BrontoYPage />} />
            <Route path="/mspconnect" element={<MSPConnectPage />} />
            <Route path="/brontocosmos" element={<BrontoCosmosPage />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/leadership/:id" element={<LeaderProfile />} />
            <Route path="/media" element={<Media />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;
